import LPNav from "./components/LPNav";
import LPHero from "./components/LPHero";
import LPBrand from "./components/LPBrand";
import ProductGrid from "./components/ProductGrid";
import ProductDetailSections from "./components/ProductDetail";
import LPFooter from "./components/LPFooter";

export default function HomePage() {
  return (
    <main className="bg-black min-h-screen w-full overflow-x-hidden">
      <LPNav />
      <LPHero />
      <LPBrand />
      <ProductGrid />
      <ProductDetailSections />
      <LPFooter />
    </main>
  );
}
